import { Avatar as MuiAvatar } from '@mui/material'
import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { AvatarSize } from './types'

export type AvatarProps = {
    size?: AvatarSize
    /**
     * Url of the image. Alternatively, pass in text or icon as a child.
     */
    src?: string
    /**
     * If the src prop is provided, alt attribute for the image.
     */
    alt?: string
    children?: ReactNode

    /* Use with care. Added to make the component usable with Chip, which
     * clones the avatar and sets its className prop.
     */
    className?: string
}

const Avatar: FC<AvatarProps> = ({ alt, src, size = 'large', children, className }) => {
    return (
        <MuiAvatar alt={alt} src={src} className={clsx(`DsAvatar-size-${size}`, className)}>
            {children}
        </MuiAvatar>
    )
}

export default Avatar
